import React from 'react'
import { map, path, pathOr, propEq } from 'ramda'

import { Col } from '../../../packages/kiti/components/structure/Grid'
import { useFormState } from '../../../packages/kiti/components/form/form/FormHandler'
import DynamicInput from '../../../components/form/DynamicInput'
import FormItem from '../../../packages/kiti/components/form/form/FormItem'
import { useInterpolations } from '../../../utils/interpolations/interpolations'
import { getGetSingleConditionValue } from '../../../modules/triggers/editV2/_helpers/singleConditionValue'
import { useRawInterpolations } from '../../../utils/interpolations/rawInterpolations'
import RecordId from '../../../components/presentation/RecordId'
import { INTEGRATION_LOGO } from '../../../modules/fields/edit/_data/integrationLogos'

const FieldsFormInputItem = ({ field, fieldValuesPath, isPropSnakeCase, canEditSignature }) => {
  const propFieldId = isPropSnakeCase ? `field_id` : `fieldId`
  const propFieldValue = `${isPropSnakeCase ? 'field_values' : 'fieldValues'}`

  fieldValuesPath = fieldValuesPath || [propFieldValue]

  const { form, handleChangeIn } = useFormState()
  const fieldValues = path(fieldValuesPath, form)

  const masks = map(path(['pattern']), pathOr([], ['masks'])(field))

  let index = fieldValues?.findIndex(propEq(propFieldId, field.id))
  if (index === -1 || index === undefined) index = fieldValues?.length || 0
  const value = path([...fieldValuesPath, index, 'value'], form)

  const onChange = value => {
    handleChangeIn([...fieldValuesPath, index], { [propFieldId]: field.id, field, value })
  }

  const checklistId = getGetSingleConditionValue(form.conditions, 'checklist_id')
  const interpolations = useInterpolations(form.entity, checklistId)
  const rawInterpolations = useRawInterpolations(form.entity, checklistId)

  const dynamicInterpolation = ['date', 'datetime', 'number'].includes(field.type)
    ? rawInterpolations
    : interpolations || []

  const isSignatureHidden = field.type === 'signature' && canEditSignature === false
  if (isSignatureHidden) return null

  return (
    <Col width="50%" wrapOn="sm">
      <RecordId labelPrefix="FIELD_ID" record={field} width="fit-content" />
      <FormItem
        label={field.name + (field.required ? '*' : '')}
        path={[...fieldValuesPath, index, 'value']}
        logo={INTEGRATION_LOGO[field.configuration?.integrationService]}
      >
        <DynamicInput
            value={value}
            onChange={onChange}
            valueType={field.type}
            options={field?.options}
            interpolations={dynamicInterpolation}
            masks={masks}
            displayAsList={field?.configuration?.displayAsList}
            integrationService={field?.configuration?.integrationService}
            integrationFieldType={field?.configuration?.integrationFieldType}
            integrationId={field?.configuration?.integrationId}
          />
      </FormItem>
    </Col>
  )
}

export default FieldsFormInputItem
